export enum REDIRECT_LINK_RESOURCES {
  EXPERIMENT = 'experiment',
  ARTIFACT = 'artifact',
  ARTIFACT_VERSION = 'artifactVersion',
  MODEL_REGISTRY = 'model_registry'
}
